import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import {
    required,
    minValue,
} from "vuelidate/lib/validators";
import store from '@/store'

export default {
    name: "DamageLossesEdit",
    components: {
        MainLayout,
        Select2Multiple,
        flatPickr,
        Loading,
    },

    data() {
        return {
            damageLossesData: {
                library_member_id: null,
                book_id: 0,
                status: null,
                description: '',
                quantity: 0,
                type: null,
            },
            currentEditedBook: {},
            getAllBooks: [],
            memberArr: null,
            bookArr: null,
            isError: false,
            submitted: false,
            isLoading: false,
            campusId: store.state.user.campus_master.campus_code,
            disabled: false,
            noDataMsg: CONFIG.NO_DATA_EXIST,
            noMemberMsg: '',
            noCategoryMsg: '',
            noBookMsg: '',
            bookTypes: CONFIG.BOOK_TYPE_VALUE,
            maxLimitBook: 0,
            bookIdStartChange: false,
            config: CONFIG,
        };
    },

    validations: {
        damageLossesData: {
            book_id: {
                required,
            },
            status: {
                required
            },
            description: {
                required,
            },
            quantity: {
                required,
                minValue: minValue(1),
            },
        },
    },

    computed: {
        isValidMember() {
            if (this.damageLossesData.library_member_id){
                if (!this.memberArr || this.memberArr.length === 0) return false;
                    return this.memberArr.some(
                        (library_member_id) => Number(library_member_id.id) === Number(this.damageLossesData.library_member_id)
                );   
            }else{
                return true;
            }
        },
        isValidBook() {
            if (!this.bookArr || this.bookArr.length === 0) return false;
            return this.bookArr.some(
                (book_id) => Number(book_id.id) === Number(this.damageLossesData.book_id)
            );
        },
        minRequired() {
            if (this.damageLossesData.type == this.bookTypes['Physical Book'] && this.damageLossesData.quantity <= 0) {
                return true;
            }
        },
        maxLimit() {
            if (this.damageLossesData.quantity > this.maxLimitBook) {
                return true;
            }
        },
        isCountableBook() {
            if (this.damageLossesData.book_id && !this.damageLossesData.book_id == 0 && this.damageLossesData.type == this.bookTypes['Physical Book']) {
                return true;
            }
        }
    },


    methods: {
        getMember() {
            let $defaultSelectOption = [{
                'id': 0,
                'text': 'Select Member'
            }];
            axios.get("/member/getList", {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                }
            })
                .then(res => {
                    if (res.data.data.length > 0) {
                        this.memberArr = $defaultSelectOption.concat(res.data.data);
                    } else {
                        this.memberArr = $defaultSelectOption;
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getBookList() {
            this.isLoading = true;
            const campusId = this.$store.state.user.campus_id;
            axios.get(`book/list`, {
                params: {
                        campusId: campusId
                    }
                })
                .then((res) => {
                    const filterEbook = res.data.data.filter(book => book.type != this.bookTypes['Ebook']);
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Book'
                    }];

                    if (res.data && res.data.data && filterEbook.length) {
                        let bookOptions = filterEbook.map(book => {
                                return {
                                    id: book.id,
                                    text: book.title
                                };
                        });

                        [{type: 0, quantity: 0}].concat(filterEbook.forEach(book => this.getAllBooks[book.id] = book));
                        this.bookArr = $defaultSelectOption.concat(bookOptions);
                        this.noBookMsg = '';
                    } else {
                        this.bookArr = $defaultSelectOption;
                        this.noBookMsg = 'No Book for this campus.';
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else {
                        console.error("Error fetching book list:", error);
                    }
                    this.isLoading = false;
                });
        },

        onMemberChange(selectedMember) {
            if (selectedMember.id === null) {
                this.damageLossesData.library_member_id = null;
            } else {
                this.damageLossesData.library_member_id = selectedMember.id;
            }
        },

        getDetail() {
            axios.get('damageAndLoss/detail/' + this.$route.params.id)
                .then((response) => {
                    if (response.data != undefined) {
                        this.damageLossesData = response.data;
                        this.damageLossesData.type = this.bookTypes["Physical Book"];
                        this.currentEditedBook = JSON.parse(JSON.stringify(response.data));
                        this.currentEditedBook.type = this.bookTypes["Physical Book"];
                        this.maxLimitBook = Number(this.getAllBooks[this.currentEditedBook.book_id].remaining_quantity) + Number(this.currentEditedBook.quantity);
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.log("Damage and Losses Detail API Error", error);
                })

        },

        validateForm() {
            this.errors = {};
            const integerValidator = (value) => Number.isInteger(Number(value));

            if (!integerValidator(this.damageLossesData.library_member_id)) {
                this.errors.library_member_id = 'Library Member must be an integer.';
            } else if (!this.isValidMember) {
                this.errors.library_member_id = 'Selected Library Member is not valid.';
            }
            
            if (this.minRequired) {
                this.errors.book_id = 'Quantity must be at least one.';
            } else if (this.maxLimit) {
                this.errors.book_id = 'Quantity must be less than quantity of book.';
            }
            return this.errors;
        },

        update() {
            if (this.disabled) return;
            this.disabled = true;
            this.submitted = true;
            if (this.$v.$invalid || this.isError) {
                return;
            }

            if (Object.keys(this.validateForm()).length) {
                return;
            }

            // Convert 0 to null before sending
            const payload = {
                ...this.damageLossesData,
                library_member_id: this.damageLossesData.library_member_id === '0' ? null : this.damageLossesData.library_member_id
            };

            axios.post(`damageAndLoss/update/${this.$route.params.id}`, payload)
                .then(res => {
                    if (res.data.success) {
                        this.$notification.success("Damage and Loss Updated Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({ name: "damageLossesList" });
                    } else {
                        this.disabled = false;
                        this.$notification.error(res.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    if (error.response.status === 422) {
                        this.$notification.error("Validation Error: " + error.response.data.message, {
                            timer: 5,
                            position: "bottomCenter"
                        });
                    }
                });
        },
        changeBook() {
            this.damageLossesData.type = this.getAllBooks[this.damageLossesData.book_id].type;
            this.damageLossesData.quantity = 0;
            this.bookIdStartChange = true;

            if (this.damageLossesData.book_id == this.currentEditedBook.book_id) {
                this.maxLimitBook = Number(this.getAllBooks[this.damageLossesData.book_id].remaining_quantity) + Number(this.currentEditedBook.quantity);
            } else {
                this.maxLimitBook = Number(this.getAllBooks[this.damageLossesData.book_id].remaining_quantity);
            }
        },
    },

    mounted() {
        this.isLoading = true;
        this.getBookList();
        this.getMember();
        this.getDetail();
    },
};
